import i18nFetch from "@/api/i18n";

const state = {
  i18nLoaded: false,
  i18nData: {},
  currentLocale: "",
};

const getters = {
  i18nLoaded: (state) => state.i18nLoaded,
  i18nData: (state) => state.i18nData,
  currentLocale: (state) => state.currentLocale,
};

const actions = {
  async fetchI18nData({ commit }, locale) {
    locale = locale === "ja" ? locale : locale === "ko" ? locale : "en";
    let i18n = await i18nFetch(locale);
    commit("setI18nData", i18n);
    commit("setCurrentLocale", locale);
  },
};

const mutations = {
  setI18nData(state, payload) {
    state.i18nData = payload;
    state.i18nLoaded = true;
  },
  setCurrentLocale(state, locale) {
    state.currentLocale = locale;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
